var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"x-small":"","color":"secondary","outlined":""},on:{"click":function($event){$event.stopPropagation();return _vm.download.apply(null, arguments)}}},[_vm._v("PDF")])
}
var staticRenderFns = []

export { render, staticRenderFns }